module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.94fe72ccad5bbf85cb7d.js");
}
